import { useEffect } from "react";
import { fbList } from "./useFirebase";
import { CANAL_AVISOS, permissaoNotificacoesAndroid } from "../utils/notificacoesAndroid";

const isAndroid = () => window.Capacitor?.getPlatform?.() === "android";
const isElectron = () => !!window.electronAPI;

export async function mostrarNotif(title, body, extra = {}) {
  if (isAndroid()) {
    try {
      const { LocalNotifications } = await import("@capacitor/local-notifications");
      if (await permissaoNotificacoesAndroid()) {
        await LocalNotifications.createChannel(CANAL_AVISOS);
        await LocalNotifications.schedule({
          notifications: [{
            title,
            body,
            id: Math.floor(Math.random() * 99999),
            channelId: CANAL_AVISOS.id,
            smallIcon: "ic_stat_notification",
            largeIcon: "ic_notification_app",
            // Sem schedule: entrega imediata, sem depender de alarme exato.
            extra,
          }]
        });
        return true;
      }
    } catch(e) { console.warn("LocalNotifications error:", e); }
    return false;
  }
  if (isElectron()) {
    window.electronAPI.showNotification?.(title, body);
    return true;
  }
  // Web browser
  if (!("Notification" in window)) return false;
  const show = () => new Notification(title, { body, icon: "/printcontrol.png" });
  if (Notification.permission === "granted") { show(); return true; }
  else if (Notification.permission !== "denied") {
    const p = await Notification.requestPermission();
    if (p === "granted") { show(); return true; }
  }
  return false;
}

export async function solicitarPermissaoNotificacao() {
  if (isAndroid()) {
    try {
      return await permissaoNotificacoesAndroid();
    } catch(e) { console.warn("LocalNotifications requestPermissions error:", e); }
    return false;
  }
  if (isElectron()) return;
  if (!("Notification" in window)) return;
  if (Notification.permission === "default") {
    await Notification.requestPermission();
  }
}

export function useNotificacoes() {
  useEffect(() => {
    const hoje = new Date();
    const hojeKey = hoje.toISOString().slice(0, 10);
    if (localStorage.getItem("notif_last_run") === hojeKey) return;
    localStorage.setItem("notif_last_run", hojeKey);

    // Notificações de agenda
    (async () => {
      try {
        const eventos = await fbList("agenda");
        const amanha = new Date(hoje); amanha.setDate(hoje.getDate() + 1);
        const amKey = amanha.toISOString().slice(0, 10);
        const hojeStr = hojeKey;
        const iconeTipo = { Entrega:"📦", Vencimento:"💰", "Reunião":"🤝", "Manutenção":"🔧", Lembrete:"🔔", Outro:"📅" };

        eventos.forEach(ev => {
          if (!ev.data) return;
          if (ev.data === hojeStr) {
            const icone = iconeTipo[ev.tipo] || "📅";
            mostrarNotif(
              `${icone} Agenda hoje — ${ev.titulo}`,
              ev.hora ? `${ev.tipo} às ${ev.hora}${ev.descricao ? ": " + ev.descricao : ""}` : `${ev.tipo}${ev.descricao ? ": " + ev.descricao : ""}`
            );
          } else if (ev.data === amKey) {
            const icone = iconeTipo[ev.tipo] || "📅";
            mostrarNotif(
              `${icone} Amanhã — ${ev.titulo}`,
              ev.hora ? `${ev.tipo} amanhã às ${ev.hora}${ev.descricao ? ": " + ev.descricao : ""}` : `${ev.tipo} amanhã${ev.descricao ? ": " + ev.descricao : ""}`
            );
          }
        });
      } catch(e) { /* silencioso */ }
    })();
  }, []);
}
